import { useState } from "react";
import { toast } from "sonner";
import { useDeleteRoomCategory } from "@/hooks/useRoomCategories";

export const useRoomCategoryDelete = () => {
  const deleteRoomCategoryMutation = useDeleteRoomCategory();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRoomCategoryDelete = async (id: string, hotelId: string) => {
    try {
      setIsLoading(true);

      await deleteRoomCategoryMutation.mutateAsync({ id, hotelId });

      toast.success("Room category deleted successfully!");
    } catch (err) {
      const message = (err as Error).message || "Delete failed";
      setError(message);
      toast.error(message);
      console.error("Error deleting room:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleRoomCategoryDelete,
    isLoading,
    error,
  };
};
